<template>
	<main role="main" style="padding-top:0px" class="right_wrapper">
		<BreadCrumbHeader
          @backCalled="getBackToList"
          :selectedName="name"
		  :tabCalled='tabCalled'
		  :selectedModule='tabCalled'
        />
		<div
			v-if="showEventListLoader"
			class="spinner-border"
			style="margin:auto;display:block;margin-top:60px"
		></div>
		<div v-else class="table_wrap">
			<table class="table" style="table-layout:fixed;" v-if="eventList.length">
				<thead>
					<tr>

						<th>Modified by</th>
						<th>Modified on </th>
						<!-- <th>Modified on clk</th>
						<th>Modified on stm</th> -->
						<!-- <th>Transaction-id</th>
						<th>Application name</th> -->
						<th>Actions</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,index) in eventList" :key="item.eventId" :class="index%2==0?'even':''">
						<td>{{(item.changed_fields && item.changed_fields.modified_by ? (item.changed_fields.modified_by == 'new_campaign_update_midnight' ? 'System' : item.changed_fields.modified_by)  : 'System')}}</td>
						<td>{{getLocalTime(item.mtime)}}</td>
						<!-- <td>{{getLocalTime(item.action_tstamp_clk)}}</td>
						<td>{{getLocalTime(item.action_tstamp_stm)}}</td> -->
						<!-- <td>{{item.transaction_id}}</td>
						<td>{{item.application_name}}</td> -->
						<td>{{getAction(item.action)}}</td>
						<td>
							<div class="row-add-edit" id = "activity-list-drop-down">
								<a href="javascript:void(0)" class="item-add-edit" data-toggle="dropdown"></a>
								<div class="dropdown-menu remove-style" aria-labelledby="dropdownMenuButton">
									<!-- <a
										class="grid-item"
										@click="viewDetailModal(item.client_query,'query',item.changed_fields)"
										href="javascript:void(0)"
									>View Query</a> -->
									<a
										class="grid-item"
										@click="viewDetailModal(item.row_data,'rowData',item.changed_fields)"
										href="javascript:void(0)"
									>Row Data</a>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<NoDataAvailable v-else></NoDataAvailable>
			</div>
		<ActivityDetailModal v-if="showModal" :data="nestedData" :dataType="nestedDataType" :modifiedData="nestedModifiedData"/>
		<ActivityFooter class="main_footer_wrap" v-if="eventList && totalActivities>0" :totalActivityDataCount="totalActivities" @getActivityData="getActivityData"></ActivityFooter>
	</main>
</template>

<script>
	import ActivityFooter from "@/components/Activity/ActivityFooter.vue"
	import ActivityDetailModal from "@/components/Activity/ActivityDetailModal.vue";
	import moment from 'moment';
	import BreadCrumbHeader from "@/components/BreadCrumbHeader.vue";
	import NoDataAvailable from '../NoDataAvailable.vue'
	export default {
		name: "Activity",
		data() {
			return {
				totalActivities:0,
				event: {
					action: "",
					actionClk: "",
					actionStm: "",
					actionTx: "",
					applicationName: "",
					changedFields: "",
					clientAddr: "",
					clientPort: "",
					rowData: "",
					transactionId: ""
				},
				eventList: [],
				showEventListLoader: true,
				parentId: "",
				calledFrom: "",
				showModal: false,
				nestedData: "",
				nestedDataType:"",
				nestedModifiedData:'',
				name:'Activity',
				tabCalled:''
			};
		},
		components: { ActivityDetailModal,ActivityFooter, BreadCrumbHeader, NoDataAvailable},
		beforeMount(){

			if(this.$route.params.campGrpId){
				this.tabCalled = 'Campaign Groups'
			}
			else {
				this.tabCalled = 'Campaign'
			}


		},
		mounted() {
			if(this.$route.params.campGrpId)
			{
				this.name = atob(this.$route.params.campGrpName)
			}
			else if(this.$route.params.campId)
			{
				this.name = atob(this.$route.params.campName)
			}
			this.setPayloadForActivity()
		},
		methods: {
			getBackToList(){
					this.$store.state.calledFromCancel = true;

					if((this.calledFrom == "campaign_group")){
						this.$router.push({ path: "/campaignGroupList" });
					}
					else if(this.calledFrom == "campaign"){
						this.$router.push({ path: "/campaignList" });
					}

			},
			setPayloadForActivity(){
				if (this.$route.params.campGrpId) {
					(this.calledFrom = "campaign_group"),
					(this.parentId = this.$route.params.campGrpId);
				} else if (this.$route.params.campId) {
					(this.calledFrom = "campaign"),
						(this.parentId = this.$route.params.campId);
				}
				if (this.parentId && this.calledFrom) {
					this.getActivityData();
				}
			},
			getBack() {},
			getLocalTime(data){
				var localTime = moment(data).calendar();
				return localTime;
			},
			getAction(type){
				if(type == 'U'){
					return 'Updated'
				}
				else if(type == 'D'){
					return 'Deleted'
				}
				else if(type == 'I'){
					return 'Inserted'
				}
				else{
					return ''
				}
			},
			viewDetailModal(data,type,changedFields) {
				this.nestedData = data;
				this.nestedDataType = type;
				this.nestedModifiedData = changedFields ;
				this.showModal = true;
				const vm =this;
				this.$nextTick(() => {
					window.$("#activityDetail").modal({
						show: true
					});
					window.$("#activityDetail").on("hide.bs.modal", function(e) {
						e.stopImmediatePropagation();
						vm.showModal = false;
					});
				});
			},
			hideActivityDetailModal() {
				this.showModal = false;
				this.nestedData= "",
				this.nestedDataType="",
				this.nestedModifiedData =''
			},
			getActivityData(data) {
				const vm = this;
				var payload = {
					id: this.parentId,
					type: this.calledFrom,
					currentPage:(data && data.currentPage)?data.currentPage:0,
					showPerPage:(data && data.showPerPage)?data.showPerPage:25,
				};
				vm.showEventListLoader = true;
				vm.totalActivities = 0;
				this.$store
					.dispatch("campaign/getActivityDataList", payload)
					.then(response => {
						vm.showEventListLoader = false;
						vm.eventList = response.data;
						vm.totalActivities = response.count
					});
			}
		}
	};
</script>
